//escape string for csv
export function escapeString(str: string | number) {
  return `"${`${str}`.replace(/"/g, '""')}"`;
}
